import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=66f982ec&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=66f982ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f982ec",
  null
  
)

export default component.exports